export default __webpack_public_path__ + "static/media/icon-eleventh-barcode.b03bdff7.svg";